import { _js, ___p } from '@ifixit/utils/localize';
import { FaIcon } from '@ifixit/ui/components/icon';
import { ToggleGroup, ToggleGroupItem } from '@ifixit/ui/components/toggle-group';
import { cn } from '@ifixit/ui/lib/utils';
import { TOGGLE_PILL_CLASS } from 'Shared/editor/toggle_pill';
import { isStepRailMode, type StepRailMode } from 'Shared/editor/use_editor_preference';

const MODE_BUTTON_CLASS = cn(TOGGLE_PILL_CLASS, 'size-8 justify-center p-0 pointer-coarse:size-10');

/** The step count and the List | Grid switch above the rail, on desktop and in the phone sheet. */
export function RailHeader({
   count,
   mode,
   onModeChange,
   className,
}: {
   count: number;
   mode: StepRailMode;
   onModeChange: (mode: StepRailMode) => void;
   className?: string;
}) {
   return (
      <div className={cn('flex items-center justify-between gap-2', className)}>
         <span className="text-sm text-gray-600">
            {___p(count, '%1 step', '%1 steps', String(count))}
         </span>
         <ToggleGroup
            type="single"
            // Radix maps a single-select ToggleGroup to `group`, which leaves
            // its `radio` children without the parent that gives them "1 of 2".
            role="radiogroup"
            aria-label={_js('Step view')}
            value={mode}
            onValueChange={next => {
               // Radix reports a re-click of the active item as ''; a view is always chosen.
               if (isStepRailMode(next)) {
                  onModeChange(next);
               }
            }}
            className="flex gap-1"
         >
            <ToggleGroupItem
               value="list"
               aria-label={_js('List view')}
               className={MODE_BUTTON_CLASS}
            >
               <FaIcon name="list" className="size-3.5" aria-hidden />
            </ToggleGroupItem>
            <ToggleGroupItem
               value="grid"
               aria-label={_js('Grid view')}
               className={MODE_BUTTON_CLASS}
            >
               <FaIcon name="grid" className="size-3.5" aria-hidden />
            </ToggleGroupItem>
         </ToggleGroup>
      </div>
   );
}
